import { Pipe, PipeTransform } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';

@Pipe({
    name: 'isEconomic',
    standalone: true,
})
export class IsEconomicPipe implements PipeTransform {
  constructor(private analyticsService: AnalyticsService) {}

  transform(rate: any[]) {
    for (let i = 0; i < rate.length; i++) {
      if (rate[i].isEconomic) {
        this.analyticsService.trackEvent({
          section: 'Detail',
          action: 'Economic Prepaid',
          label: 'Show',
          nonInteraction: true,
        });
        break;
      }
    }
    return rate;
  }
}
